/* VOID THEME: base interactivity (vanilla JS, no build step required) */
(function () {
  'use strict';

  /* ---------------------------------------------------------------- */
  /* Mobile navigation                                                 */
  /* ---------------------------------------------------------------- */
  var navToggle = document.querySelector('[data-mobile-nav-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (navToggle && mobileNav) {
    navToggle.addEventListener('click', function () {
      var isOpen = mobileNav.classList.toggle('is-open');
      navToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      document.body.classList.toggle('nav-open', isOpen);
    });
  }

  /* ---------------------------------------------------------------- */
  /* Quantity selectors ( + / - buttons )                              */
  /* ---------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quantity-change]');
    if (!btn) return;
    var wrapper = btn.closest('.quantity-selector');
    var input = wrapper && wrapper.querySelector('input[type="number"]');
    if (!input) return;
    var step = parseInt(input.step, 10) || 1;
    var min = parseInt(input.min, 10) || 1;
    var value = parseInt(input.value, 10) || min;
    value = btn.getAttribute('data-quantity-change') === 'increase' ? value + step : Math.max(min, value - step);
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------------------------------------------------------- */
  /* Cart line quantity change -> /cart/change.js                      */
  /* ---------------------------------------------------------------- */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-quantity-input]');
    if (!input) return;
    var line = input.getAttribute('data-line');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: input.value })
    })
      .then(function (r) { return r.json(); })
      .then(function () { window.location.reload(); })
      .catch(function (err) { console.error(err); });
  });

  /* ---------------------------------------------------------------- */
  /* Product media gallery: click a thumbnail to swap the main image   */
  /* ---------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-product-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-product-gallery]');
    if (!gallery) return;
    var main = gallery.querySelector('[data-product-main-image]');
    if (main) {
      main.src = thumb.getAttribute('data-full-src') || thumb.src;
      main.srcset = '';
    }
    gallery.querySelectorAll('[data-product-thumb]').forEach(function (t) {
      t.closest('.product__thumb').classList.remove('is-active');
    });
    thumb.closest('.product__thumb').classList.add('is-active');
  });

  /* ---------------------------------------------------------------- */
  /* Variant picker: swatches update the hidden variant id input       */
  /* ---------------------------------------------------------------- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var variantsJson = form.querySelector('[data-variants-json]');
    if (!variantsJson) return;
    var variants;
    try { variants = JSON.parse(variantsJson.textContent); } catch (err) { return; }

    function selectedOptions() {
      var opts = [];
      form.querySelectorAll('[data-option-index]').forEach(function (input) {
        if (input.type === 'radio' && !input.checked) return;
        opts[parseInt(input.getAttribute('data-option-index'), 10)] = input.value;
      });
      return opts;
    }

    function findVariant() {
      if (variants.length === 1) return variants[0];
      var opts = selectedOptions();
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function updateUI() {
      var variant = findVariant();
      var idInput = form.querySelector('[name="id"]');
      var submitBtn = form.querySelector('[data-add-to-cart]');
      var priceEl = document.querySelector('[data-product-price]');
      if (!variant) {
        if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = submitBtn.getAttribute('data-unavailable-text') || 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (submitBtn) {
        submitBtn.disabled = !variant.available;
        submitBtn.textContent = variant.available
          ? (submitBtn.getAttribute('data-add-text') || 'Add to cart')
          : (submitBtn.getAttribute('data-sold-out-text') || 'Sold out');
      }
      if (priceEl && variant.price != null) {
        priceEl.setAttribute('data-current-price', variant.price);
        var formatted = (variant.price / 100).toFixed(2);
        var amountEl = priceEl.querySelector('[data-price-amount]');
        if (amountEl) amountEl.textContent = priceEl.getAttribute('data-currency-symbol') + formatted;
      }
    }

    form.addEventListener('change', updateUI);
    updateUI();
  });

  /* ---------------------------------------------------------------- */
  /* AJAX add-to-cart + header cart count bump                         */
  /* ---------------------------------------------------------------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var submitBtn = form.querySelector('[data-add-to-cart]');
    var formData = new FormData(form);

    if (submitBtn) submitBtn.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) {
          throw new Error(res.data && res.data.description ? res.data.description : 'Could not add to cart');
        }
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        var countEls = document.querySelectorAll('[data-cart-count]');
        countEls.forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        window.location.href = window.themeRoutes && window.themeRoutes.cart ? window.themeRoutes.cart : '/cart';
      })
      .catch(function (err) {
        var errorEl = form.querySelector('[data-form-error]');
        if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
      })
      .finally(function () {
        if (submitBtn) submitBtn.classList.remove('is-loading');
      });
  });

  /* ---------------------------------------------------------------- */
  /* Newsletter form: basic client-side confirmation state             */
  /* ---------------------------------------------------------------- */
  document.querySelectorAll('[data-newsletter-form]').forEach(function (form) {
    form.addEventListener('submit', function () {
      form.classList.add('is-submitting');
    });
  });
})();
